import { createAsyncThunk } from '@reduxjs/toolkit'
import postValidateAddress from '../../api/postValidateAddress'
import _ from 'lodash'
import REQUEST_STATUS from '../common/REQUEST_STATUS'
import { isValid } from '../slice/form'

export const validateCode1Address = createAsyncThunk(
  'code1/validate-address',
  async ({ path, address }) => {
    return await postValidateAddress(address)
  }
)

const setFailure = (state, action) => {
  _.set(state, `${action.meta.arg.path}.requestStatus`, REQUEST_STATUS.FAILED)
  const path = action.meta.arg.path.split('.')
  path.pop()
  _.set(state, `${path.join('.')}.code1validated.value`, 'true')
  _.set(state, `${path.join('.')}.code1validated.valid`, isValid(
    _.get(state, `${path.join('.')}.code1validated`))
  )
}

export const validateCode1AddressReducer = {
  [validateCode1Address.pending]: (state, action) => {
    _.set(state, `${action.meta.arg.path}.requestStatus`, REQUEST_STATUS.IN_PROGRESS)
  },
  [validateCode1Address.fulfilled]: (state, action) => {
    if (_.isEmpty(action.payload)) {
      /**
       * If an error occurs in the backend on this call, a 200 is returned with no data.
       * Cannot treat this as a fulfilled action, because no suggested address was returned.
       */
      setFailure(state, action)
    } else {
      _.set(state, `${action.meta.arg.path}.requestStatus`, REQUEST_STATUS.SUCCEEDED)
      Object.keys(action.payload).forEach(addressPiece => {
        _.set(
          state,
          `${action.meta.arg.path}.${addressPiece}.value`,
          addressPiece === 'state' ? action.payload[addressPiece].abbreviation : action.payload[addressPiece]
        )
      })
    }
  },
  [validateCode1Address.rejected]: (state, action) => {
    setFailure(state, action)
    state.error = action.error.message
  },
}